import styled from 'styled-components';
import { IconQuestionFilled } from '@prisjakt/ui/icon/question-filled';
import { IconCloseFilled } from '@prisjakt/ui/icon/close-filled';
import { IconCheckFilled } from '@prisjakt/ui/icon/check-filled';
import { layout } from 'src/components/base';

export const BooleanPropertyValue = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};
`;

const BOOLEAN_ICON_SIZE = 16;

export const BooleanTrueIcon = styled(IconCheckFilled).attrs({
  size: BOOLEAN_ICON_SIZE,
  color: 'positive500',
})``;

export const BooleanFalseIcon = styled(IconCloseFilled).attrs({
  size: BOOLEAN_ICON_SIZE,
  color: 'negative700',
})``;

export const BooleanUnknownIcon = styled(IconQuestionFilled).attrs({
  size: BOOLEAN_ICON_SIZE,
  color: 'base500',
})``;
